import React, { useMemo } from 'react';
import ReactSVG from 'react-svg';
import { useTheme } from 'styled-components';
import { IconWrapper } from './styles';
import { ICON_RENDERERS } from './constants';


/**
 * Standard icon component w controlled color for v2 icons
 * - `type` should be a file prefix from `assets/v2-icons/`
 */
const Icon = ({
  type,
  size = 'md',
  selected = false,
  disabled = false,
  color,
  hoverColor,
  selectedColor,
  inheritColor = false,
  label,
  className = '',
  style: styleProp = {},
  children,
}) => {
  const theme = useTheme();

  const resolvedSize = typeof size === 'number'
    ? `${size}px`
    : (theme.iconSize[size] ?? theme.iconSize.md);

  const resolvedColor = useMemo(() => {
    if (color) return color;
    if (disabled) return theme.grey3;
    if (selected) return selectedColor ?? theme.primary;
    if (inheritColor) return undefined;
    return theme.textMedium;
  }, [color, disabled, selected, selectedColor, inheritColor, theme]);

  const wrapperStyle = {
    ...(resolvedColor !== undefined && { color: resolvedColor }),
    opacity: disabled && !color ? 0.45 : 1,
    ...styleProp,
  };

  const a11yProps = label
    ? { role: 'img', 'aria-label': label }
    : { 'aria-hidden': true };

  const CustomRenderer = ICON_RENDERERS[type];

  return (
    <IconWrapper
      $width={resolvedSize}
      $height={resolvedSize}
      $hoverColor={disabled ? undefined : hoverColor}
      data-icon={type}
      className={`icon ${className}`}
      style={wrapperStyle}
      {...a11yProps}
    >
      {children ?? (
        CustomRenderer
          ? <CustomRenderer selected={selected} disabled={disabled} />
          : <ReactSVG
            src={require(`../../assets/v2-icons/${type}.svg`)}
            onError={(err) => console.error(`Failed to load icon: ${type}`, err)}
          />
      )}
    </IconWrapper>
  );
};

export default Icon;